import React, { useEffect, useState } from 'react'
import UserLookForm, { UniPulseUrlParams } from './UserLookForm'
import UserActivityContainer from './UserActivityContainer'
import { useFetchActivityUsers } from '../../hooks/queries'
import { UserList } from './StyledComponents'
import GroupingPane from './GroupingPane'
import {  useIamUserProfileStore } from '../../Store/index';
import { useTranslation } from 'react-i18next'

export default function UserLookupMain() {
    const { data: usersData, mutate: mutateUser } = useFetchActivityUsers();
    const [ groupData, setGroupData ] = useState<any[]>([]);
    const [ groupType, setGroupType ] = useState('ALL');
    const {t} = useTranslation();
    const [ selectedView, setSelectedView ] = useState({ label: t('pulse.all'), value:'ALL' });
    const [ selectedLoginId, setSelectedLoginId ] = useState('');
    const [ searchParams, setSearchParams ] = useState<UniPulseUrlParams>();
    const [ queryParams, setQueryParams ] = useState<UniPulseUrlParams>();
    const iamUserInfo = useIamUserProfileStore((state:any) => state.iamUserInfo);
    
    const search = (searchParams: UniPulseUrlParams) => {
       setSearchParams({...searchParams});
       setSelectedLoginId('');

       mutateUser({...searchParams, groupType: (searchParams.loginid) ? 'IP' : 'ALL' })
       setSelectedView((searchParams.loginid) ? 
            { label: t('pulse.ip'), value:'IP' } : 
            { label: t('pulse.all'), value:'ALL'});
        setGroupType((searchParams.loginid) ? 'IP' : 'ALL');
      }

    const stores = iamUserInfo?.fullUser?.stores;
    const storeMap = stores?.reduce((acc : any, store: any) => { acc[store.id] = store.name; return acc }, {} as any)

    const formatTreeData = (arr:any[]) => {
        try{
            const loginArr = arr && arr.length && arr?.reduce((acc, user) => {
            const paths = user?.loginIds?.reduce((acc2:any[], login:string) => { 
                    const groupName = groupType === 'STORE' ? storeMap[user.id] : user.id
                    acc2.push([groupName + ` (${user.loginIdCount})`, login, user.id]);
                    return acc2;
                }, []);
                return acc.concat(paths);
            }, []);
            return loginArr?.map((tarr:any[]) => {
                return { path: [tarr[0],tarr[1]], loginId: tarr[1], groupId:tarr[2] };
            })
        }
        catch(e) {
            console.log('Error in formatTreeData', e)
        }
    }

    useEffect(() => {
        setGroupData(formatTreeData(usersData as any[]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usersData]);

    const onGroupChange = (option: any) => {
        setSelectedView(option);
        setSelectedLoginId('');
        setGroupType(option.value);
       searchParams &&  mutateUser({ ...searchParams as UniPulseUrlParams, groupType: option.value});
    }

    const onUserSelect = (loginid: string,groupId:string) => {
        setSelectedLoginId("");
        let params = {...searchParams};
        if(groupType === 'STORE'){
            params.storeids = groupId;
        }
        else if(groupType === 'IP'){
            params.ip = groupId;
        }
        setQueryParams(params as any);
        loginid && setSelectedLoginId(loginid);
    }

  return (
   <div>
        <UserLookForm searchHandler={search} />
        <UserList>
            <GroupingPane selectedView={selectedView}  userList={groupData} onGroupChange={onGroupChange} onUserSelect={onUserSelect} />
            <div style={{border:'1px solid Grey', borderRadius: '8px', margin:'5px', flex:'4'}}>
                { selectedLoginId && <UserActivityContainer
                    startTime={queryParams?.startDate as string}
                    endTime={queryParams?.endDate as string}
                    loginId={selectedLoginId as string}
                    ip={queryParams?.ip as string}
                    storeId={queryParams?.storeids as string}
                    enterpriseId={queryParams?.enterpriseId as string} />
                } 
            </div>
        </UserList>
   </div>
  )
}
